import { createElement } from 'react'
import DiskOptimization from '~/dashboard/azure_master_optimizations/disk_optimization'
import ReactController from './react_controller'

export default class AzureDiskOptimizationController extends ReactController {
  static values = {
    organizationId: String,
    masterOptimizationId: String,
    masterOptimizationStatus: String,
  }

  createComponent() {
    return createElement(DiskOptimization, {
      organizationId: this.organizationIdValue,
      masterOptimizationId: this.masterOptimizationIdValue,
      masterOptimization: {
        id: this.masterOptimizationIdValue,
        status: this.masterOptimizationStatusValue,
      },
    })
  }
}
